import React, { FC, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type ProtectedRouteProps = {
    isAuthenticated: boolean;
    redirectPath: string;
    element: ReactElement;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({
    isAuthenticated,
    redirectPath,
    element,
}): ReactElement => {
    const location = useLocation();

    if (!isAuthenticated) {
        // Preserve the destination the user actually asked for (state.from) so the login
        // form can send them back to it, and use replace so this bounce does not leave a
        // history entry. Without replace, pressing Back from the login page returns to
        // this same unauthenticated route, which immediately redirects again, ping-ponging
        // Back between the two.
        return <Navigate to={redirectPath} state={{ from: location }} replace />;
    }

    return element;
};

export default ProtectedRoute;
